import { useRoutes } from "@hooks/useRoutes";
import {
  ComponentProps,
  FromSanityGraphQL,
  ResolvedLink,
} from "@ts/components";
import { type SectionImageGrid } from "@ts/sanity";
import React, { FC } from "react";

type ImageGridInputProps = ComponentProps & FromSanityGraphQL<SectionImageGrid>;

type ImageGridOutputProps = ImageGridInputProps & {
  handleClick: () => void;
  link?: ResolvedLink;
};

export const withImageGrid =
  (Component: FC<ImageGridOutputProps>) =>
  ({
    name = "ImageGrid",
    analytics,
    ctaLink,
    ...rest
  }: ImageGridInputProps) => {
    const { linkResolver } = useRoutes();
    const link = linkResolver(ctaLink);

    Component.displayName = name;

    return <Component {...rest} link={link} />;
  };
